import typia from 'typia'

import { type ArtworkType } from '@/graphql/creator-platform/generated'
import { useLayoutStore } from '@/store/layoutStore'

import { sentry } from './sentry'
import { LocalStorage } from './storage'

export interface FavoriteItem {
  artworkType: ArtworkType
  id: string
}
const isFavoriteItem = typia.createIs<FavoriteItem>()
const layoutStore = useLayoutStore()

function isSameFavoriteItem(aItem: FavoriteItem, bItem: FavoriteItem): boolean {
  return aItem.id === bItem.id && aItem.artworkType === bItem.artworkType
}

let cacheFavoriteArtwork: FavoriteItem[] | null = null
function setFavoriteArtworkIds(artworks: FavoriteItem[]): void {
  // 不要讓不需要的資料進來
  const newArtworks = artworks.map((item) => ({
    id: item.id,
    artworkType: item.artworkType,
  }))
  localStorage.setItem(LocalStorage.FavoriteArtwork, JSON.stringify(newArtworks))
  cacheFavoriteArtwork = newArtworks
}
/**
 * 回傳由舊到新加入的最愛作品
 */
export function getFavoriteArtworks(): readonly FavoriteItem[] {
  if (cacheFavoriteArtwork !== null) {
    return cacheFavoriteArtwork
  }
  const value = localStorage.getItem(LocalStorage.FavoriteArtwork)
  if (value === null) {
    return []
  }
  const artworks: FavoriteItem[] = []
  try {
    const needCheckArtworks: unknown = JSON.parse(value)
    if (!Array.isArray(needCheckArtworks)) {
      return []
    }
    artworks.push(
      ...needCheckArtworks.filter((item: unknown): item is FavoriteItem => isFavoriteItem(item)),
    )
  } catch {
    sentry.error('parse favorite artwork failed', { value, artworks })
  }
  cacheFavoriteArtwork = artworks
  return artworks
}

export function isFavoriteArtwork(artwork: FavoriteItem): boolean {
  return getFavoriteArtworks().some((item) => isSameFavoriteItem(item, artwork))
}

export function addFavoriteArtwork(addArtwork: FavoriteItem): void {
  const isFavorite = isFavoriteArtwork(addArtwork)
  if (isFavorite) {
    return
  }
  const artworks = [...getFavoriteArtworks()]
  artworks.push(addArtwork)
  setFavoriteArtworkIds(artworks)
  layoutStore.animateHeart()
}

export function removeFavoriteArtwork(removeArtworkId: string): void {
  const artworks = getFavoriteArtworks()
  setFavoriteArtworkIds(artworks.filter((artwork) => artwork.id !== removeArtworkId))
}
